import React from 'react';
import { ThemeProvider } from './context/ThemeContext';
import { ToastProvider } from './context/ToastContext';
import { ConfirmProvider } from './context/ConfirmContext';
import { AppProvider, useApp } from './context/AppContext';
import { LoginPage } from './pages/LoginPage';
import { AppShell } from './layout/AppShell';
import { LandingPage } from './pages/LandingPage';
import { AppUpdatePrompt } from './components/AppUpdatePrompt';

function Main() {
  const { token, labels } = useApp();
  const pathname = window.location.pathname || '/';
  const isLandingPath = pathname === '/';
  const isLoginPath = pathname === '/login';

  let page = null;
  if (isLandingPath) page = <LandingPage />;
  else if (isLoginPath) page = token ? <AppShell /> : <LoginPage />;
  else page = token ? <AppShell /> : <LoginPage />;

  return (
    <>
      {page}
      {/* Show on login too — stale iOS Safari/PWA needs Hard refresh before sign-in */}
      <AppUpdatePrompt labels={labels} />
    </>
  );
}

function App() {
  return (
    <ThemeProvider>
      <ToastProvider>
        <ConfirmProvider>
          <AppProvider>
            <Main />
          </AppProvider>
        </ConfirmProvider>
      </ToastProvider>
    </ThemeProvider>
  );
}

export default App;
